import React from 'react';

interface ProfessionalDescriptionProps {
  description: string;
}

const ProfessionalDescription: React.FC<ProfessionalDescriptionProps> = ({ description }) => {

  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/50 p-4">
      <div className="prose prose-gray max-w-none">
        <p className="text-gray-600 leading-relaxed text-lg font-light whitespace-pre-wrap">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ProfessionalDescription;
